/**
 * Plan 9b (spec 2026-10-02 upacara-bersama-dan-akun 5.4): the display preferences that follow
 * the account, as the API and the app exchange them at /api/akun/preferensi. A body names the
 * three preferences only, never an account: the account is the session's (the API takes it
 * from the token). The answer adds whose they are and the parish defaults a device falls back
 * to when the account has none. Imported by subpath (`@satu/shared/preferensi`).
 */
import { z } from 'zod'
import { GERAKAN, KEPADATAN, UKURAN_TEKS } from './schema/contract'

/** PATCH's body and the stored values: the three, all present, nothing else. */
export const preferensiSchema = z.strictObject({
  kepadatan: z.enum(KEPADATAN),
  ukuran_teks: z.enum(UKURAN_TEKS),
  gerakan: z.enum(GERAKAN),
})
export type Preferensi = z.infer<typeof preferensiSchema>

/** The parish's `kepadatan_bawaan` and `ukuran_teks_bawaan` (Pengaturan paroki). */
export const bawaanParokiSchema = z.strictObject({
  kepadatan: z.enum(KEPADATAN),
  ukuran_teks: z.enum(UKURAN_TEKS),
})
export type BawaanParokiKabel = z.infer<typeof bawaanParokiSchema>

/** GET's and PATCH's answer. */
export const jawabanPreferensiSchema = z.strictObject({
  pengguna_id: z.string().min(1),
  preferensi: preferensiSchema.nullable(),
  bawaan_paroki: bawaanParokiSchema.nullable(),
})
export type JawabanPreferensi = z.infer<typeof jawabanPreferensiSchema>
